import { BaseRequestModel } from "./BaseModel/BaseRequestModel";

export class ProcurementActivityReportRequestmodel extends BaseRequestModel{
    procurementPlanDetailID:number
    publishedDocumentID:number
}